import { render, staticRenderFns } from "./HotelkontingentModal.vue?vue&type=template&id=43bfd434"
import script from "./HotelkontingentModal.vue?vue&type=script&lang=js"
export * from "./HotelkontingentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports